<div class="image_properties">
  @if (dynamicsInitialized) {
    <div style="padding-top: 30px; padding-bottom: 100px">
      <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
      </dynamic-form>
    </div>
  }
  <button style="margin: 8px" (click)="openCors()" mat-flat-button>
    <mat-icon>lightbulb</mat-icon>
    {{ 'general.importantNotes' | transloco }}
  </button>
  <br/>
</div>
